// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headline[data-v-c68b84dc]{font-weight:700}.roles-chip-group[data-v-c68b84dc]{display:flex;flex-wrap:wrap}.user-chip[data-v-c68b84dc]{font-size:12px}.users-group[data-v-c68b84dc]{max-height:200px;overflow-y:scroll}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
